import axios from 'axios'
import config from '../helpers/config'

const getFeatureFlags = (jwt: string) => {
	const xApiKey = '928f8012a8a770a72a85dfa1aab06e28'
	return axios
		.request({
			method: 'get',
			url: `${config.getCTPath()}/feature_flags?`,
			headers: {
				JWT: jwt,
				'x-api-key': xApiKey,
			},
		})
		.then(function (response) {
			return response.data
		})
}

export default {
	getFeatureFlags,
}
